import { Component, OnInit } from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {LocalizeRouterService} from '@gilsdav/ngx-translate-router';
import {CookieService} from 'ngx-cookie';
import {languages} from '@shared/helpers';
import {Select} from '@ngxs/store';
import {BillingSelectors} from '@store/billing';
import {Observable} from 'rxjs';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  @Select(BillingSelectors.getTvOwnerBalance) balance$!: Observable<number>;
  public languages: { label: string, value: string }[] = languages;
  public lang: string;

  constructor(private translate: TranslateService,
              private localize: LocalizeRouterService,
              private cookie: CookieService) {
    this.lang = translate.currentLang;
  }

  ngOnInit(): void {
  }

  public setLang(lang: string): void {
    this.lang = lang;
    this.translate.use(lang);
    this.localize.changeLanguage(lang);
    this.cookie.put('dWLang', lang);
  }
}
